




import { Component, Vue } from "vue-property-decorator";
import StickyBottomBar from "@/components/Quotation/StickyBottomBar.vue";

@Component({
  components: {
    StickyBottomBar,
  },
})
export default class CompanyShow extends Vue {}
